import React, { useEffect, useState } from "react";
import { connect } from "redux-zero/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./globalCssFile.css";
import Login from "./screens/Login";
import CreateNewEvent from "./screens/Events/createNewEvent";
import EventList from "./screens/Events/EventsList";
import EventDetails from "./screens/EventDetails";
import GameScreen from "./screens/Games/GameScreen";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EditEvent from "./screens/Events/EditEvent";
import JoinEventLive from "./screens/JoinEventLive";
import SocialMaster from "./screens/Social/SocialMaster";
import SuperScreen from "./screens/SuperScreen";
import SocialCarousel from "./screens/Social/socialCarousel/SocialCarousel";
import SocialSlideshow from "./screens/Social/socialSlide/SocialSlideshow";
import SocialOutput from "./screens/Social/SocialOutput";
import SocialDynamicMasonry from "./screens/Social/socialDynamicMasonry/SocialDynamicMasonry";
import FixedMasonry from "./screens/Social/fixedMasonry/FixedMasonry";
import EventScreen_Old from "./screens/Output/EventScreen_Old";
import { updateSignallingConfigs } from "./utils/signallingConfig";
import { AppContextProvider } from "./contexts/App.Context";
import { isCameraPermissionGranted } from "./utils/utility";
import Output from "./screens/Social/controllable/Output";
import FilterCamOutput from "./screens/FilterCam/FilterCamOutput";

import JoinLightshow from "./screens/LightShow/JoinLightshow";

function App(props) {
  const [cameraPermission, setCameraPermission] = useState(false);
  const triggerUpdateSignalligConfigs = async () => {
    if (window.location.pathname?.toLowerCase().includes("joinlightshow")) {
      return;
    }
    await updateSignallingConfigs(props);
  };

  useEffect(() => {
    if (!window.location.hash?.includes("page=light_show")) {
      return;
    }
    async function checkCameraPermission() {
      const isCamAllowed = await isCameraPermissionGranted();
      setCameraPermission(isCamAllowed);
    }
    checkCameraPermission();
  }, []);
  useEffect(() => {
    triggerUpdateSignalligConfigs();
  }, [cameraPermission]);
  const onCameraPermissionChange = (newValue) => {
    setCameraPermission(newValue);
  };

  return (
    <AppContextProvider>
      <ToastContainer />

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/events" element={<EventList />} />
          <Route path="/createNewEvent" element={<CreateNewEvent />} />
          <Route path="/editEvent" element={<EditEvent />} />
          <Route path="/eventDetails" element={<EventDetails />} />
          <Route path="/eventScreen" element={<EventScreen_Old />} />
          <Route
            path="/joinEventLive"
            element={
              <JoinEventLive
                onCameraPermissionChange={onCameraPermissionChange}
              />
            }
          />
          <Route path="/gameScreen" element={<GameScreen />} />
          <Route path="/social-output/:eventId" element={<SocialOutput />} />
          <Route path="/controllable-output/:eventId" element={<Output />} />
          <Route path="/filtercam-output/:eventId" element={<FilterCamOutput />} />
          <Route path="/Social" element={<SocialMaster />} />
          <Route path="/SuperScreen" element={<SuperScreen />} />
          <Route path="/SocialCarousel" element={<SocialCarousel />} />
          <Route path="/SocialSlideshow" element={<SocialSlideshow />} />
          <Route
            path="/SocialDynamicMasonry"
            element={<SocialDynamicMasonry />}
          />
          <Route path="/SocialFixedMasonry" element={<FixedMasonry />} />
          <Route path="/JoinLightShow" element={<JoinLightshow />} />
        </Routes>
      </BrowserRouter>
    </AppContextProvider>
  );
}

export default connect((state) => ({ serverConfig: state.serverConfig }))(App);
